import React from 'react';
import glamorous from 'glamorous';
import { MENU_ENTRIES } from '../constants';
import ImgWithSource from '../img-with-source';

import zipUpload1Img from '../../../../assets/images/docs/zip-upload/zip-upload-1.png';
import zipUpload2Img from '../../../../assets/images/docs/zip-upload/zip-upload-2.png';
import zipUpload3Img from '../../../../assets/images/docs/zip-upload/zip-upload-3.png';
import zipUpload4Img from '../../../../assets/images/docs/zip-upload/zip-upload-4.png';

const ZipUploadProcess = () => (
  <div data-subsection={MENU_ENTRIES.uploadingZipToPortalManualProcess}>
    <h4>Manual upload process</h4>
    <glamorous.Ul
      className="pt-list"
      css={{
        listStyle: 'decimal',
      }}
    >
      <li>
        Go to the OECD <i>GlobalRecalls</i> website: <a href="https://globalrecalls.oecd.org"
                                                        target="_blank">https://globalrecalls.oecd.org</a>.
      </li>
      <li>
        <glamorous.Div>
          Click on the Administration link on the top right corner of the website.
        </glamorous.Div>
        <br/>
        <ImgWithSource src={zipUpload1Img}/>
        <br/>
      </li>
      <li>
        Enter your unique API key in the <strong>API key</strong> field.
      </li>
      <li>
        Click on <strong>Select Recalls Zip</strong> and select the zip file located on your computer.
      </li>
      <li>
        <glamorous.Div>
          Click on the <strong>Upload</strong> button.
        </glamorous.Div>
        <br/>
        <ImgWithSource src={zipUpload2Img}/>
        <br/>
      </li>
    </glamorous.Ul>
    <br/>
    <br/>
    <div className="pt-callout pt-intent-warning pt-icon-info-sign">
      <h5 className="pt-callout-title">IMPORTANT</h5>
      In the case of a critical error (e.g. incorrect or missing API key, and/or incorrect ZIP file), an error message
      will immediately be sent to the user/server. The upload procedure will stop and the file will not be uploaded into
      the portal. For example, the error in the screenshot below relates to an incorrect API key.
    </div>
    <br/>
    <ImgWithSource src={zipUpload3Img}/>
    <br/>
    <br/>
    <br/>
    <p>
      If there are no errors, the ZIP file will be loaded and processed into the database in background mode. An email
      will be sent to the email address(es) linked to the API key, outlining the results of the recall import. The
      procedure will terminate normally (see screenshot below).
    </p>
    <ImgWithSource src={zipUpload4Img}/>
  </div>
);

export default ZipUploadProcess;



// WEBPACK FOOTER //
// ./src/views/static/import-documentation/uploading-zip-to-portal/zip-upload-process.js